import React from 'react';
import { passThroughTranslation } from '@colonist/i18n';
import { T } from '@colonist/ui';
import { PatchNoteTypeBadge } from './PatchNoteTypeBadge/PatchNoteTypeBadge.tsx';
import { PatchNoteImageLink } from './PatchNoteImageLink/PatchNoteImageLink.tsx';
import styles from './PatchNoteContentItem.module.scss';
export function PatchNoteContentItem({ content, onExternalClick, onProfileClick }) {
    const hasImages = content.beforeImgUrl != undefined || content.afterImgUrl != undefined;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.contentItem
    }, /*#__PURE__*/ React.createElement(PatchNoteTypeBadge, {
        type: content.type,
        link: content.link,
        onExternalClick: onExternalClick
    }), /*#__PURE__*/ React.createElement("p", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: content.description
        }
    }), content.contributors.length > 0 ? /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(T, {
        id: passThroughTranslation(' (Thanks')
    }), content.contributors.map((contributor, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: contributor
        }, ' ', /*#__PURE__*/ React.createElement("span", {
            className: styles.link,
            onClick: ()=>onProfileClick(contributor)
        }, contributor), index < content.contributors.length - 1 ? ',' : '')), /*#__PURE__*/ React.createElement(T, {
        id: passThroughTranslation(')')
    })) : null, hasImages ? /*#__PURE__*/ React.createElement("span", {
        className: styles.imageLinksContainer
    }, /*#__PURE__*/ React.createElement(T, {
        id: passThroughTranslation(' (')
    }), content.beforeImgUrl ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.patchNote.before',
            options: {
                context: 'description'
            }
        }
    }), /*#__PURE__*/ React.createElement(PatchNoteImageLink, {
        type: "before",
        imagePath: content.beforeImgUrl,
        onExternalClick: onExternalClick
    }), content.afterImgUrl ? ' ' : null) : null, content.afterImgUrl ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.patchNote.after',
            options: {
                context: 'description'
            }
        }
    }), /*#__PURE__*/ React.createElement(PatchNoteImageLink, {
        type: "after",
        imagePath: content.afterImgUrl,
        onExternalClick: onExternalClick
    })) : null, /*#__PURE__*/ React.createElement(T, {
        id: passThroughTranslation(' )')
    })) : null));
}
